import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@lingzhi/design-tokens/css'
// 焦点环、中文排版（混排间距、标点挤压、禁则）、减少动效等基础行为
import '@lingzhi/design-tokens/css/foundation'
import './theme/global.css'
import { App } from './app/App'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
